<template>
  <b-card border-variant="dark">
    <div class="height-user">
      <h5>Operadores</h5>

      <div class="select-queue mb-2">
        <select
          class="form-control form-control-sm queue-select"
          v-model="changeQueue"
        >
          <option value="*">Todas as Filas</option>
          <option
            v-for="(queue, idx) in userChatQueues"
            :key="idx"
            :value="queue.id"
          >
            {{ queue.name }}
          </option>
        </select>
      </div>

      <b-table
        small
        striped
        bordered
        :fields="fields"
        :items="paginatedItems"
        responsive="sm"
      >
        <template #cell(user)="row">
          {{ row.item.user }}
        </template>

        <template #cell(login)="row">
          {{ row.item.login }}
        </template>

        <template #cell(status)="row">
          <b-badge :variant="getStatus(row.item.status).variant">
            {{ getStatus(row.item.status).txt }}
          </b-badge>
        </template>

        <template #cell(active)="row">
          <b-badge :variant="row.item.active === 1 ? 'success' : 'secondary'">
            {{ row.item.active === 1 ? 'Sim' : 'Não' }}
          </b-badge>
        </template>

        <template #cell(opcoes)="row">
          <i
            class="fa fa-eye image-button"
            title="Visualizar detalhes"
            @click.prevent="abrirModalUsers(row.item)"
          ></i>
        </template>
      </b-table>

      <div class="d-flex justify-content-between align-items-center mt-2">
        <small>Total de {{ displayItems.length }} registros</small>
        <b-pagination
          v-model="currentPage"
          :total-rows="displayItems.length"
          :per-page="perPage"
          align="right"
          size="sm"
        />
      </div>
    </div>

    <modal-users ref="dtModalUsers" />
  </b-card>
</template>

<script>
import { mapMutations } from "vuex";
import moment from "moment";
import modalUsers from "./modalUsers.vue"; 

const socket = require("../../../modules/realtime/service/service");

export default {
  name: "TbUsers",
  props: ['filter'],
  components: {
    modalUsers
  },
  data() {
    return {
      fields: [
        { key: "user",   label: "Operador",      class: "text-center" },
        { key: "login",  label: "Login",         class: "text-center" },
        { key: "status", label: "Status Login",  class: "text-center" },
        { key: "active", label: "Ativo",         class: "text-center" },
        { key: "opcoes", label: "Ações",         class: "text-center" },
      ],

      allUsers: [],
      operatorAvailable: {},      
      operatorInAttendance: [], 
      userChatQueues: [],
      changeQueue: "*",
      items: [],
      perPage: 10,
      currentPage: 1,
    };
  },
  computed: {
    displayItems() {
      if (this.filter === '*') return this.items;
      return this.items.filter(u => u.status === this.filter);
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.displayItems.slice(start, start + this.perPage);
    }
  },
  created() {
    axios.get("/user/list")
      .then(({ data }) => {
        this.allUsers = data.data.map(u => ({
          id:             u.id,
          user:           u.name,
          extension_line: u.extension_line,
          queueChat:      Array.isArray(u.queuechat) ? u.queuechat : [], // array de IDs
          active:         u.active,
          status:         u.status || "c_deslogado",
          opcoes:         u.opcoes || { ramal: u.extension_line, fila: [] },
          login:          u.login || "00:00:00"
        })).filter(u => u.active == 1);
        this.items = this.getOperators(this.changeQueue);
        this.setLogChat(this.items);
      })
      .catch(console.error);

    axios.get("/realtime/listUsers")
      .then(({ data }) => {
        // data = { disponivel: { "9090": {...}, … }, atendimento: [ … ] }
        this.operatorAvailable    = data.disponivel || {};
        this.operatorInAttendance = data.atendimento || [];
        this.items = this.getOperators(this.changeQueue);
        this.setLogChat(this.items);
      })
      .catch(console.error);

    axios.get("/listQueueChat")
      .then(({ data }) => {
        this.userChatQueues = data;

        this.items = this.getOperators(this.changeQueue);
        this.setLogChat(this.items);
      })
      .catch(console.error);

    socket.connection.on("availableChat", obj => {
      this.operatorAvailable = obj.disponivel || {};
      this.items = this.getOperators(this.changeQueue);
      this.setLogChat(this.items);
    });

    socket.connection.on("attendanceChat", obj => {
      this.operatorInAttendance = obj.atendimento.filter(
        (t, i, arr) => i === arr.findIndex(x => x.operator === t.operator)
      );
      this.items = this.getOperators(this.changeQueue);
      this.setLogChat(this.items);
    });
  },
  methods: {
    ...mapMutations([
      "setLogChat",
      "setLogInfo"
    ]),

    getStatus(stt) {
      if (stt === "c_deslogado")      return { txt: "Deslogado",       variant: "danger"  };
      if (stt === "a_em_atendimento") return { txt: "Em Atendimento",  variant: "warning" };
      if (stt === "b_ativo")          return { txt: "Disponível",      variant: "primary" };
      return { txt: "Desconhecido",    variant: "secondary" };
    },

    abrirModalUsers(userItem) {

      const names = Array.isArray(userItem.filaIDs)
        ? userItem.filaIDs.map(idFila => {
            const encontrado = this.userChatQueues.find(
              q => String(q.id) === String(idFila)
            );
            if (encontrado) {
              return encontrado.name;
            }
            if (
              window.user &&
              typeof window.user.getChatQueues === "function" &&
              typeof window.user.getQueue === "function"
            ) {
              const allIDs = window.user.getChatQueues(); 
              const allNames = window.user.getQueue(); 
              const idx = allIDs.indexOf(String(idFila));
              if (idx >= 0 && allNames[idx]) {
                return allNames[idx];
              }
            }
            return idFila;
          })
        : [];

      const transformed = {
        ...userItem,       
        queueChat: names   
      };

      this.setLogInfo(transformed);
      if (this.$refs.dtModalUsers) {
        this.$refs.dtModalUsers.openModal();
      } else {
        console.warn("ModalUsers não encontrado em $refs");
      }
    },
    getOperators(queue) {
      const base = this.allUsers
        .filter(u => {
          return queue === "*" || (u.queueChat && u.queueChat.includes(String(queue)));
        })
        .map(u => ({
          id:       u.id,
          user:     u.user,
          ramal:    String(u.extension_line),
          login:    "00:00:00",
          status:   "c_deslogado",
          opcoes:   { ramal: String(u.extension_line), fila: [] },
          active:   u.active,
          filaIDs:  Array.isArray(u.queueChat) ? u.queueChat.slice() : []
        }));

      return base.map(us => {
        const avail  = this.operatorAvailable[us.ramal];
        const attend = this.operatorInAttendance.find(a => a.operator === us.ramal);
        const queueNames = us.filaIDs.map(idFila => {
          const encontrado = this.userChatQueues.find(
            q => String(q.id) === String(idFila)
          );
          if (encontrado) {
            return encontrado.name;
          }
          if (
            window.user &&
            typeof window.user.getChatQueues === "function" &&
            typeof window.user.getQueue === "function"
          ) {
            const allIDs = window.user.getChatQueues();
            const allNames = window.user.getQueue();     
            const idx = allIDs.indexOf(String(idFila));
            if (idx >= 0 && allNames[idx]) {
              return allNames[idx];
            }
          }
          return idFila;
        });

        if (avail && attend) {
          const filasStatus = us.filaIDs.map(el =>
            String(el) === String(attend.queue) ? "a_em_atendimento" : "b_ativo"
          );
          filasStatus.sort();

          return {
            id:        us.id,
            user:      us.user,
            ramal:     us.ramal,
            login:     moment(avail.login).format("HH:mm:ss"),
            status:    filasStatus[0],
            opcoes:    { ramal: us.ramal, fila: filasStatus },
            active:    us.active,
            filaIDs:   us.filaIDs,
            queueChat: queueNames
          };
        }

        if (avail) {
          return {
            id:        us.id,
            user:      us.user,
            ramal:     us.ramal,
            login:     moment(avail.login).format("HH:mm:ss"),
            status:    "b_ativo",
            opcoes:    { ramal: us.ramal, fila: ["b_ativo"] },
            active:    us.active,
            filaIDs:   us.filaIDs,
            queueChat: queueNames
          };
        }

        return {
          id:        us.id,
          user:      us.user,
          ramal:     us.ramal,
          login:     "00:00:00",
          status:    "c_deslogado",
          opcoes:    { ramal: us.ramal, fila: ["c_deslogado"] },
          active:    us.active,
          filaIDs:   us.filaIDs,
          queueChat: queueNames
        };
      });
    }
  },

  watch: {
    changeQueue(q) {
      this.items = this.getOperators(q);
      this.setLogChat(this.items);
      this.currentPage = 1;
    },
  }
};
</script>

<style scoped>
.height-user {
  max-height: 890px;
}
.image-button {
  cursor: pointer;
  margin: 0 .25rem;
}
</style>
